import { render, staticRenderFns } from "./BookedTransports.vue?vue&type=template&id=1067cbb9&scoped=true&"
import script from "./BookedTransports.vue?vue&type=script&lang=js&"
export * from "./BookedTransports.vue?vue&type=script&lang=js&"
import style0 from "./BookedTransports.vue?vue&type=style&index=0&id=1067cbb9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1067cbb9",
  null
  
)

export default component.exports